import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FallaufgabeLernbegleiterTeilaufgabeTable, TeilaufgabenSolutionTable } from '@reflact/ipkv-types';
import { MessageService } from 'primeng/api';
import { Button } from "primeng/button";
import { TableModule } from "primeng/table";
import { Toast } from 'primeng/toast';
import { TextareaModule } from 'primeng/textarea';
import { Api } from '../../../api';
import { ChatService } from '../chat.service';
import { PasteTrackingService } from '../../../paste-tracking.service';

@Component({
  selector: 'app-table',
  imports: [
    Button,
    TableModule,
    Toast,
    CommonModule,
    FormsModule,
    TextareaModule
  ],
  templateUrl: './table.html',
  styleUrl: './table.scss'
})
export class Table implements OnInit {
  public chatService = inject(ChatService);
  public api = inject(Api);
  private readonly messageService = inject(MessageService);
  private readonly pasteTracking = inject(PasteTrackingService);

  public ngOnInit() {
    this.loadTableAnswers();
  }

  public async onKeyEnter(row: number, col: number, text: string, e: KeyboardEvent) {
    if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
      this.pasteTracking.trackKeystroke();
    }
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      if (this.selectedTeilaufgabe.table[row][col].isEditable) {
        this.selectedTeilaufgabe.table[row][col].solution = text + '\n';
      }
    }
  }

  public get selectedAufgabe() {
    const fallaufgabe = this.api.fallaufgabe;
    return fallaufgabe?.aufgaben.find(a => a._id == this.api.fallaufgabeStatus?.userSelectedAufgabenId);
  }

  public get selectedTeilaufgabe() {
    return this.selectedAufgabe?.teilaufgaben.find((ta) => {
      return ta.teilaufgabenIndex == this.chatService.selectedTeilaufgabeTable
    }) as FallaufgabeLernbegleiterTeilaufgabeTable;
  }

  protected async saveAnswer(row: number, col: number, content: string) {
    await this.api.saveTableCell(this.selectedTeilaufgabe._id, row, col, content);
    this.messageService.add({
      severity: 'success',
      summary: 'Gespeichert',
      detail: 'Deine Tabelleneingabe wurde gespeichert.',
      life: 1500
    });
  }

  protected loadTableAnswers() {
    const solution = this.api.solutions.value.find(s => s.teilaufgabenId == this.selectedTeilaufgabe._id && s.type == "table") as TeilaufgabenSolutionTable | null;
    if (!solution) return;
    for (const [row, answer] of solution.answers.entries()) {
      if (answer !== null) {
        for (const [col, item] of answer.entries()) {
          if (item !== null) {
            if (this.selectedTeilaufgabe.table[row][col].isEditable) {
              this.selectedTeilaufgabe.table[row][col].solution = item;
            }
          }
        }
      }
    }
  }

  public onQuestionCopy() {
    if (!this.selectedAufgabe || !this.selectedTeilaufgabe) return;
    void this.api.trackCopyEvent(this.selectedTeilaufgabe._id, this.selectedAufgabe._id, 'frage');
  }

  public onTablePaste(e: ClipboardEvent) {
    this.pasteTracking.trackPaste(e, "table");
  }
}
